import { faker } from "@faker-js/faker";

export const createCreator = ({ id, avatar, name, username }) => {
    return {
        id: id || faker.string.numeric(7),
        avatarUrl: avatar,
        name,
        username,
        __typename: "CreatorProfileType"
    };
};
